export type NativeQuickAccessCredentialAction = 'wait' | 'refresh' | 'suspend'
export type NativeQuickAccessCredentialSessionAction = 'preserve' | 'replace'

export function nativeQuickAccessCredentialPolicy(input: {
  authRestoring: boolean
  authError: string | null
  userId: string | null
}): NativeQuickAccessCredentialAction {
  if (input.authRestoring || input.authError) return 'wait'
  return input.userId ? 'refresh' : 'suspend'
}

export function nativeQuickAccessCredentialSessionPolicy(input: {
  expectedUserId: string
  sessionUserId: string | null
  hasAccessToken: boolean
  readFailed: boolean
}): NativeQuickAccessCredentialSessionAction {
  if (input.readFailed) return 'preserve'
  return input.sessionUserId === input.expectedUserId && input.hasAccessToken
    ? 'replace'
    : 'preserve'
}
